import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { InfoCircle } from "react-bootstrap-icons";

function InfoTooltip({
  text,
  children,
  placement = "bottom",
  iconSize = 16,
  color,
  id,
}) {
  const tooltipId = id || `info-tooltip-${Math.random().toString(36).slice(2, 9)}`;

  const overlay = (
    <Tooltip id={tooltipId}>{children ?? text}</Tooltip>
  );

  return (
    <OverlayTrigger placement={placement} overlay={overlay} trigger={["hover", "focus"]}>
      <span
        role="button"
        tabIndex={0}
        aria-label="More information"
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          color: color ?? "#6b7280",
        }}
      >
        <InfoCircle size={iconSize} />
      </span>
    </OverlayTrigger>
  );
}

export default InfoTooltip